export default "__VITE_ASSET__Bg7A_lCn__"